<template>
  <v-app>
    <v-snackbar
      v-model="error.display"
      :timeout=6000
      color="error"
      right
      top
      >
        {{error.text}}
         <v-btn
          dark
          text
          @click="error.display = false"
        >
          Fermer
        </v-btn>
      </v-snackbar>

    <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="9" class="align-self-center">
          <v-container>
            <v-form @submit.prevent="onSearchSubmit" ref="form">
              <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-bind="conf.search" v-model="form.search">
                      <template v-slot:append-outer>
                        <v-tooltip
                          bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                          </template>
                          réf externe de type C.xxx.xxx.xxxx.A /<br> réf interne de type AC.xxx.xxx.xxxx
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <TolerantField 
                      v-bind="conf.diam_ext" 
                      v-model="form.diam_ext" 
                      :tolerance="form.diam_ext_tolerance"
                      :updateTolerance="updateTolerance('diam_ext_tolerance')"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <TolerantField 
                      v-bind="conf.diam_int" 
                      v-model="form.diam_int" 
                      :tolerance="form.diam_int_tolerance"
                      :updateTolerance="updateTolerance('diam_int_tolerance')"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <TolerantField 
                      v-bind="conf.diam_fil" 
                      v-model="form.diam_fil" 
                      :tolerance="form.diam_fil_tolerance"
                      :updateTolerance="updateTolerance('diam_fil_tolerance')"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <TolerantField 
                      v-bind="conf.lo_libre" 
                      v-model="form.lo_libre" 
                      :tolerance="form.lo_libre_tolerance"
                      :updateTolerance="updateTolerance('lo_libre_tolerance')"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                     <TolerantField 
                      v-bind="conf.raideur" 
                      v-model="form.raideur" 
                      :tolerance="form.raideur_tolerance"
                      :updateTolerance="updateTolerance('raideur_tolerance')"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-select v-bind="conf.matiere" v-model="form.matiere"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" class="mx-auto">
                    <v-btn
                      type="submit"
                      color="primary"
                      :loading="isLoading"
                      large
                      outlined
                      block
                    >Rechercher</v-btn>
                  </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="d-none d-sm-block align-self-center">
          <img class="ressort-form-img" src="http://ressorts-delain.fr/images/ressort_form.png" />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-data-table
        v-if="searchResponse.result"
        :headers="conf.table.headers"
        :mobile-breakpoint=0
        :items="searchResponse.result"
        :footer-props="{
          'items-per-page-options': [10],
          'pageText': '{0}-{1} sur {2}',
        }"
        :server-items-length="searchResponse.pagination.total"
        class="elevation-1"
        :options="options"
        :loading="isLoading"
        show-select
        must-sort
        @update:options="updatePagination"
      >
        <template v-slot:header.data-table-select></template>
        <template v-slot:item.data-table-select={item}>
          <div class="d-flex">
            <v-tooltip v-if="inArray(item)" top>
              <template v-slot:activator="{ on }">
                <v-icon 
                  tag="button"
                  v-on="on"
                  @click="removeFromQuotation(item.ref_interne)"
                >mdi-minus</v-icon>
              </template>
              <span>Enlever de ma demande de devis</span>
            </v-tooltip>

            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <v-icon 
                  tag="button"
                  v-on="on"
                  @click="addToQuotation(item)"
                >mdi-plus</v-icon>
              </template>
              <span>Ajouter à ma demande de devis</span>
            </v-tooltip>
            <v-icon tag="button" @click.stop="openModal(item)">mdi-information-outline</v-icon>
          </div>
        <!-- <v-icon tag="button">mdi-minus</v-icon> -->
      </template>
      </v-data-table>

      <div v-if="hasQuotation">
        <div class="display-2 my-10">Votre demande de devis.</div>
        <v-simple-table class="qty-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th></th>
                <th class="text-left">Name</th>
                <th class="text-left">Quantité</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="quotation in quotationArray" :key="quotation.name">
                <td class="remove">
                   <v-icon 
                      tag="button"
                      @click="removeFromQuotation(quotation.ref_interne)"
                    >mdi-minus
                    </v-icon>
                </td>
                <td>{{ quotation.name }}</td>
                <td>
                  <v-text-field
                    v-model="quotation.quantity"
                    outlined
                    dense
                    single-line
                    no-label
                  /></td>
              </tr>
            </tbody>
          </template>
      </v-simple-table>
      <v-col cols="12">
        <v-btn
          type="submit"
          color="primary"
          class="my-8"
          large
          @click="sendDevis"
        >Envoyer une demande de devis</v-btn>
      </v-col>
      </div>
      <v-dialog
      v-model="dialog"
      max-width="450"
    >
      <v-card v-if="dialogItem">
        <v-card-title class="headline">{{ dialogItem.ref_interne }}</v-card-title>
        <v-card-text>
         <div class="attributes">
          <div class="attribute">
              <div class="attribute__title">Référence:</div>
              <div class="attribute__value align-end">{{ dialogItem.ref_interne }}</div>
          </div>
           <div class="attribute">
            <div class="attribute__title">Diamètre extérieur:</div>
            <div class="attribute__value align-end">{{ dialogItem.diam_ext }}</div>
          </div>
          <div class="attribute">
            <div class="attribute__title">Diamètre intérieur:</div>
            <div class="attribute__value align-end">{{ dialogItem.diam_int }}</div>
          </div>
          <div class="attribute">
            <div class="attribute__title">Diamètre fil:</div>
            <div class="attribute__value align-end">{{ dialogItem.diam_fil }}</div>
          </div>
          <div class="attribute">
            <div class="attribute__title">Longueur:</div>
            <div class="attribute__value align-end">{{ dialogItem.lo_libre }}</div>
          </div>
          <div class="attribute">
            <div class="attribute__title">Raideur:</div>
            <div class="attribute__value align-end">{{ dialogItem.raideur }}</div>
          </div>
          <div class="attribute">
            <div class="attribute__title">Matière:</div>
            <div class="attribute__value align-end">{{ dialogItem.matiere }}</div>
          </div>
          <div class="attribute">
              <div class="attribute__title"> Longueur a bloc:</div>
              <div class="attribute__value align-end">{{ dialogItem.lc_lg_a_bloc }}</div>
          </div>
          <div class="attribute">
              <div class="attribute__title"> Pas:</div>
              <div class="attribute__value align-end">{{ dialogItem.pas }}</div>
          </div>
          <div class="attribute">
              <div class="attribute__title"> Longueur autorisée:</div>
              <div class="attribute__value align-end">{{ dialogItem.longueur_autorise }}</div>
          </div>
          <div class="attribute">
              <div class="attribute__title"> Poids:</div>
              <div class="attribute__value align-end">{{ dialogItem.poids }}</div>
          </div>
          <div class="attribute">
              <div class="attribute__title"> Rapport d'enroulement:</div>
              <div class="attribute__value align-end">{{ dialogItem.rapport_enroulement }}</div>
          </div>
        </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import http from './services/http';
import _ from 'lodash';
import TolerantField from './components/TolerentField';

function buildIntFormData({ min, max, ...rest }){
  const minStr = min.toString().replace(/\./, ',');
  const maxStr = max.toString().replace(/\./, ',');
  return {
    placeholder: `Entre ${minStr} et ${maxStr}`,
    outlined: true,
    min,
    max,
    dense: true,
    type: 'number',
    rules: [
      v => !v || v >= min || `Saisir au minimum ${minStr}`,
      v => !v || v <= max || `Saisir au maximum ${maxStr}`,
    ],
    ...rest,
  }
}

function serializeFormAndOptions(formData, options){
  const data = _.omitBy(formData, x => (x === undefined || x === false || x.toString().trim() === ''));
  const sortBy = _.get(options, 'sortBy[0]');
  const sortDesc = _.get(options, 'sortDesc[0]', false);
  return { 
    ...data,
    page: options.page,
    sortBy,
    sortDesc,
  };
}

export default {

  name: 'App',
  props: {
    callback: { type: Function },
  },
  components: { TolerantField },
  created(){
    window.resetDevisForm = this.cleanUp
  },
  data: () => ({
    dialog: undefined,
    dialogItem: undefined,
    checkbox: false,
    options: {},
    error: {
      display: undefined,
      text: undefined,
    },
    isLoading: false,
    form: {
      search: undefined,
      diam_ext: undefined,
      diam_ext_tolerance: false,
      diam_int: undefined,
      diam_int_tolerance: false,
      diam_fil: undefined,
      diam_fil_tolerance: false,
      type: undefined,
      lo_libre: undefined,
      lo_libre_tolerance: false,
      raideur: undefined,
      raideur_tolerance: false,
    },
    searchResponse: {
      result: undefined,
    },
    quotationArray: [],
    conf: {
      table: {
        headers: [
          { value: 'ref_interne', text: 'Référence' },
          { value: 'diam_ext', text: 'Diamètre extérieur', width: 110 },
          { value: 'diam_int', text: 'Diamètre intérieur', width: 110 },
          { value: 'diam_fil', text: 'Diamètre fil', width: 110 },
          { value: 'lo_libre', text: 'Longueur', width: 110 },
          { value: 'raideur', text: 'Raideur', width: 110 },
          { value: 'matiere', text: 'Matière', width: 110 },
        ],
      },

      search: {
        label: 'Référence',
        placeholder: 'Rechercher une référence',
        outlined: true,
        dense: true
      },
      diam_ext: buildIntFormData({ 
         min: 2.5,
         max: 110,
         label: 'Diamètre extérieur : De',
      }),
       diam_fil: buildIntFormData({ 
         min: 0.3,
         max: 12,
         label: 'Diamètre fil : d',
      }),
       diam_int: buildIntFormData({ 
         min: 1.5,
         max: 96,
         label: 'Diamètre intérieur : Di',
      }),
      matiere: {
        label: 'Type de matière',
        items: ['Acier', 'Inox 302'],
        placeholder: 'Matière',
        outlined: true,
        dense: true
      },
       lo_libre: buildIntFormData({ 
         min: 1.68,
         max: 775.188,
         label: 'Longueur : Lo',
      }),
       raideur: buildIntFormData({ 
         min: 0.00900,
         max: 685.271,
         label: 'Raideur : R en N/mm',
      }),
    }
  }),
  computed: {
    hasQuotation: function () {
      return !_.isEmpty(this.quotationArray);
    },
  },
  methods: {
    updateTolerance(toleranceField) {
      return (value) => {
        this.form[toleranceField] = value;
        console.log(toleranceField, value, this.form[toleranceField]);
      }
    },
    async onSearchSubmit() {
      if (this.isLoading || !this.$refs.form.validate()) return;
      this.options = {
        page: 1,
        sortBy: [ "ref_interne" ],
        sortDesc: [false],
      };
      this.searchResponse = {
        result: undefined,
        pagination: {
          page: 1,
        },
      };
      this.search();
    },
    cleanUp(){
      this.quotationArray = [];
      this.form.search = '';
      this.searchResponse = {};
    },

    async search(){
      this.isLoading = true;
      try {
        const {data } = await http.get('/api/search', { params: serializeFormAndOptions(this.form, this.options) });
        this.searchResponse = data;
      } catch(err) {
        this.error = {
          display: true,
          text: 'Impossible de récupérer des résultats.'
        };
      } finally{
        this.isLoading = false;
      }
    },

    updatePagination(pagination) {
      const opts = _.pick(pagination, ['page', 'sortBy', 'sortDesc']);
      if (_.isEqual(opts, this.options)) return;
      this.options = opts;
      this.search();
    },
    addToQuotation(item){
      this.quotationArray.push({ ref_interne: item.ref_interne, name: `${item.ref_interne} (${item.matiere})`, quantity: 1 })
    },

    removeFromQuotation(ref_interne) {
      this.quotationArray = this.quotationArray.filter(x => x.ref_interne !== ref_interne);
    },
    inArray(item) {
      return this.quotationArray.find(x => item.ref_interne === x.ref_interne);
    },
    sendDevis(){
      this.callback(this.quotationArray);
      this.cleanUp();
    },
    openModal(item){
      this.dialog = true;
      this.dialogItem = item;
    }
  },
};
</script>

<style lang="css">
  img.ressort-form-img{
    margin: auto;
    display: block;
    max-width: 100%;
  }
  .qty-table fieldset legend {
    width: auto !important;
  }
  td.remove{
    width: 56px;
  }
  .v-data-table .v-input {
    max-width: 100px;
  }
  .v-data-table .v-input__slot {
    min-height: 30px !important;
    height: 30px !important;
    margin-bottom: 0 !important;
  }
  .v-data-table .v-text-field__details {
    display: none;
  }

  .attribute {
    display: flex;
  }

  .attribute .attribute__title {
    flex: 2;
  }
  .attribute .attribute__value {
    flex: 1;
    font-weight: bold;
  }
</style>